import { useToast } from "@chakra-ui/react";
import { useContext } from "react";
import { useIntl } from "react-intl";

import { LocaleContext } from "@nens/react/contexts";

// Saving in a useState doesnt work because it gets emptied on locale change.
let lastLocale: string | null = null;
export const ShowToastOnLocaleChange = () => {
  const intl = useIntl();
  const toast = useToast();
  const { locale } = useContext(LocaleContext);

  if (lastLocale !== locale) {
    if (lastLocale) {
      toast({
        title: intl.formatMessage({
          id: "success",
          defaultMessage: "Success!",
        }),
        description: intl.formatMessage({
          id: "success.language_changed",
          defaultMessage: "Successfully changed language.",
        }),
      });
    }
    lastLocale = locale;
  }
  return null;
};
